<template>
  <div class="contents_wrapper">
    <Header
      :btnType="showCheckin ? 'checkin' : (showCheckout ? 'checkout' : '')"
      :now="currentNow"
      @click_header_btn="doAction"
    />
    <div class="contents">
      <div class="room_main">
        <!-- チェックイン状態によりテキスト表示切替 -->
        <div v-if="showCheckin" class="room_status_text">チェックインする</div>
        <div v-if="showCheckout" class="room_status_text">チェックアウトする</div>
        <div class="room_info" :class="{'loading' : processing}">
          <div class="room_info_detail">
            <template v-if="loaded">
              <div v-if="!meeting" class="room_info_badge checkin-wait">
                <div class="info_badge_text">空室</div>
              </div>
              <div v-else-if="meeting.isAllDay" class="room_info_badge checkin-now">
                <div class="info_badge_text">利用中</div>
              </div>
              <div
                v-else-if="showCheckout || (otherUser && meeting.checkins.length)"
                class="room_info_badge checkin-now"
              >
                <div class="info_badge_text">チェックイン中</div>
              </div>
              <div v-else-if="showCheckin || otherUser" class="room_info_badge checkin-wait">
                <div class="info_badge_text">チェックイン待ち</div>
              </div>
              <div v-else class="room_info_badge checkin-wait">
                <div class="info_badge_text">チェックイン可能待ち</div>
              </div>
            </template>
            <div
              v-if="room"
              class="info_detail_title"
              :class="{has_meeting : meeting}"
            >{{room.name}}</div>
            <MeetingInfomation
              v-if="meeting"
              v-bind:time="formatDate(meeting.startDate) + '-' +  formatDate(meeting.endDate)"
              v-bind:subject="meeting.subject"
              v-bind:userName="meeting.organizer.display"
              v-bind:userAddress="meeting.organizer.id"
            />
          </div>
        </div>
      </div>
    </div>
    <Extend
      :isActive="room && showExtendBooking"
      :isCanBooking="room && !meeting && loaded"
      :isExpanded="expanded"
      @click_extend="() => { if(processing) return; $router.push({ path: `/select/${room.id}`, query: { startTime: meeting.endDate.getTime(), subject: meeting.subject, iclUid: meeting.icalId } })} "
      @click_booking="() => { if(processing) return; $router.push({ path: `/select/${room.id}` })} "
    />
    <AlertMessage @hideMessage="afterMessageAction" />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Extend from "../components/room/Extend.vue";
import AlertMessage from "../components/AlertMessage.vue";
import MeetingInfomation from "../components/MeetingInfomation.vue";

import Store from "../store";
import checkinService from "../services/checkinService";
import checkoutService from "../services/checkoutService";
import meetingService from "../services/meetingService";
import roomService from "../services/roomService";
import loggerService from "../services/loggerService";
import moment from "moment";

const store = new Store();

export default {
  components: {
    Header,
    MeetingInfomation,
    Extend,
    AlertMessage
  },
  data: function() {
    return {
      afterMessageAction: () => {},
      /**
       * 現在の会議室情報
       */
      room: null,
      /**
       * ロード中
       */
      loaded: false,
      /**
       * 処理中
       */
      processing: false,
      /**
       * 延長処理終了
       */
      expanded: false,
      /**
       * 開催中の会議
       */
      meeting: null,
      /**
       * チェックインのアイコンを表示するかどうか
       */
      showCheckin: false,
      /**
       * チェックアウトのアイコンを表示するかどうか
       */
      showCheckout: false,
      /**
       * 関係者でない
       */
      otherUser: false,
      /**
       * 予約延長ボタンを表示するかどうか
       */
      showExtendBooking: false,
      /**
       * 今すぐ予約を表示するかどうか
       */
      isCanBooking: true,
      /**
       * 自動でチェックイン・チェックアウトするかどうか
       */
      isAutoAction: false,
      /**
       * NFCを利用するかどうか
       */
      isNfcPriority: store.tenant.isNfcPriority,
      /**
       * 今すぐ予約の時の予約終了時間
       */
      searchdTime: null,
      /**
       * 処理完了時に画面下に表示するメッセージ
       */
      noBookingMessage: "",
      /**
       * トーストで表示するメッセージ
       */
      alartMessage: "",
      /**
       * トーストメッセージを表示するかどうか
       */
      showAlertMessage: false,
      currentNow: new Date()
    };
  },
  watch: {
    meeting: {
      handler: function(val) {
        // 参加者かどうか
        var isParticipant =
          val.requiredUsers.some(val => {
            return (
              store.account.toUpperCase() == val.id.toUpperCase() ||
              store.mail.toUpperCase() == val.id.toUpperCase()
            );
          }) ||
          val.optionalUsers.some(val => {
            return (
              store.account.toUpperCase() == val.id.toUpperCase() ||
              store.mail.toUpperCase() == val.id.toUpperCase()
            );
          }) ||
          val.organizer.id.toUpperCase() == store.account.toUpperCase() ||
          val.organizer.id.toUpperCase() == store.mail.toUpperCase();
        // ユーザー自身がチェックインしたか。
        var iWasCheckedIn = val.checkins.some(val => {
          return store.account == val;
        });
        this.showCheckin =
          isParticipant &&
          !iWasCheckedIn &&
          !val.isAllDay &&
          val.startDate <
            moment(new Date())
              .add(store.tenant.allowMinCheckinBefore, "m")
              .toDate();
        this.showCheckout = isParticipant && iWasCheckedIn && !val.isAllDay;
        this.otherUser = !isParticipant && !iWasCheckedIn;
        this.showExtendBooking = isParticipant && iWasCheckedIn;
        if (this.isAutoAction) {
          this.isAutoAction = false;
          if (this.showCheckin) this.checkedIn();
          else if (this.showCheckout) this.checkout();
        }
        if (val.checkouts.length) {
          this.isCanBooking = false;
          this.noBookingMessage = "チェックアウト済み";
        }
      },
      deep: true
    }
  },
  created: function() {
    loggerService.pageView("Room");
    var _this = this;
    var roomId = this.$route.params.roomId;
    this.expanded = this.$route.query["expanded"] ? true : false;
    this.isAutoAction = this.$route.query["nfc"] ? true : false;
    this.searchdTime = this.$route.query["bookon"]
      ? new Date(this.$route.query["bookon"])
      : null;
    roomService.getRooms().then(function(ret) {
      _this.room = ret.find(e => e.id == roomId);
      if (_this.room) {
        _this.fetchData();
      } else {
        alert(
          "管理者にご連絡下さい。",
          () => {
            _this.moveHome();
          },
          "NFCタグのデータが不正です。",
          "閉じる"
        );
      }
    });
  },
  methods: {
    doAction: function() {
      this.showCheckin
        ? this.checkedIn()
        : this.showCheckout
        ? this.checkout()
        : () => {};
    },
    fetchData: function() {
      var _this = this;
      _this.currentNow = new Date();
      if (this.$route.query["meeting"]) {
        // 通常遷移の時
        meetingService.getActiveEvent(_this.room.address, this.getTargetEvent);
      } else {
        // 通知やNFCで遷移した時は現在〜15分のものだけ取得する
        meetingService.getEvent(
          _this.room.address,
          _this.currentNow,
          moment(_this.currentNow)
            .add(15, "m")
            .toDate(),
          this.getTargetEvent
        );
      }
    },
    getTargetEvent: function(events) {
      var selectedMeeting = this.$route.query["meeting"];
      if (selectedMeeting) {
        events = events.filter(function(value) {
          return value.icalId == selectedMeeting;
        });
      }
      if (events.length) {
        this.meeting = meetingService.extractCurrentMeeting(events, this.room);
      }
      this.loaded = true;
    },
    formatDate: function(date) {
      return moment(date).format("HH:mm");
    },
    checkedIn: function() {
      loggerService.pageView("Checkin");
      var _this = this;
      _this.processing = true;
      checkinService.doCheckin(_this.meeting.icalId, _this.room.id, "", () => {
        _this.meeting.checkins.push(store.account);
        _this.processing = false;
        _this.afterMessageAction = () => {};
        _this.showMessage("チェックインしました");
        loggerService.info("checked-in");
      });
    },
    doCheckOutImpl: function() {
      loggerService.pageView("Checkout");
      var _this = this;
      checkoutService.doCheckout(
        _this.meeting.icalId,
        _this.room.id,
        "",
        () => {
          _this.processing = false;
          _this.isCanBooking = false;
          _this.noBookingMessage = "チェックアウト済み";
          _this.meeting.checkouts.push(store.account);
          _this.afterMessageAction = () => {
            _this.$router.push({ path: `/main` });
          };
          _this.showMessage("チェックアウトしました");
          loggerService.info("checked-out");
        }
      );
    },
    checkout: function() {
      var _this = this;
      if (_this.processing || !confirm("チェックアウトしますか？")) return;
      _this.processing = true;
      // 余裕を持たせるために2分後に設定
      var endDate = moment(new Date())
        .add(2, "m")
        .toDate();
      _this.$emit("onProcessing");
      // まだチェックアウトされてないかを確認
      meetingService
        .getEventWithOutCheckins(
          store.account,
          _this.meeting.endDate,
          _this.meeting.endDate
        )
        .then(function(ret) {
          if (
            !ret.events.length ||
            !ret.events.find(e => {
              return e.icalId == _this.meeting.icalId;
            })
          ) {
            _this.afterMessageAction = () => {
              _this.$router.push({ path: `/main` });
            };
            _this.showMessage(
              "既にチェックアウトされているか、会議が終了しています。"
            );
          }

          // 終了時刻が元の終了時刻より後
          if (endDate > _this.meeting.endDate) {
            _this.doCheckOutImpl();
          } else if (endDate < _this.meeting.startDate) {
            // 終了時刻が元の開始時刻より前
            meetingService
              .updateEndTime(_this.meeting.icalId, _this.meeting.startDate)
              .then(() => {
                _this.doCheckOutImpl();
              });
          } else {
            // それ以外
            meetingService
              .updateEndTime(_this.meeting.icalId, endDate)
              .then(() => {
                _this.doCheckOutImpl();
              });
          }
        });
    },
    moveHome: function() {
      this.$router.push({
        path: `/main`
      });
    },
    booking: function() {
      this.processing = false;
      this.isCanBooking = false;
      this.noBookingMessage = "予約リクエスト済み";
      this.showMessage("予約をリクエストしました");
      loggerService.pageView("Booking");
    },
    extend: function(evt) {
      this.processing = false;
      this.isCanBooking = false;
      this.noBookingMessage = `延長リクエスト済み<br>(${this.formatData(
        evt.startDate
      )}〜${this.formatData(evt.endDate)})`;
      this.showMessage("延長をリクエストしました");
      loggerService.pageView("Extend");
    },
    showMessage: function(msg) {
      let event;
      try {
        event = new CustomEvent("alertMessage", { detail: msg });
      } catch (e) {
        event = document.createEvent("CustomEvent");
        event.initCustomEvent("alertMessage", false, false, msg);
      }
      window.dispatchEvent(event);
    },
    extendSearch: function(time) {
      this.$router.push({
        path: `/result`,
        query: {
          targetTime: time.getTime(),
          transitionName: "slide_bottom"
        }
      });
    }
  }
};
</script>

<style lang="scss">
.room_main {
  width: 100%;
  height: calc(100% - 130px);
  padding: 0 20px 20px;
  box-sizing: border-box;
  overflow-y: auto;
}

.room_status_text {
  color: $txtColor;
  font-size: 20px;
  width: 100%;
  text-align: center;
  box-sizing: border-box;
  letter-spacing: -3px;
}

/** 会議情報 **/
.room_info {
  position: relative;
  width: 100%;
  background-color: #fff;
  border-radius: 5px;
  margin-top: 20px;
}

.room_info_badge {
  width: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px;
  box-sizing: border-box;
  border-radius: 50px;
  margin: 10px auto;
  padding: 10px 0;
}

.room_info_badge.checkin-wait {
  border: 3px solid #dddddd;
}

.room_info_badge.checkin-now {
  border: 3px solid $txtColor;
}

.info_badge_icon {
  width: 50px;
}

.info_badge_icon > img {
  width: 40px;
}

.info_badge_text {
  color: $txtColor;
  font-size: 16px;
}

.room_info_detail {
  padding: 5px 10px 30px;
  box-sizing: border-box;
}

.checkin-wait .info_badge_text {
  color: #dddddd;
}

.info_detail_title {
  font-size: 16px;
  line-height: 1.4;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  box-sizing: border-box;
}
.info_detail_title.has_meeting {
  border-bottom: 1px solid #c7c3c2;
  padding-bottom: 18px;
  margin-bottom: 18px;
}
.detail_list_item {
  display: flex;
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.detail_list_item:first-child {
  padding-top: 0;
}

.detail_list_item:last-child {
  padding-bottom: 0;
}

.detail_list_icon {
  width: 30px;
}

.detail_list_icon > img {
  width: 20px;
}

.detail_list_text {
  width: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.4;
}
</style>